export async function requestJson(url: string) {
    if (url.startsWith('/')) {
        if (!url.startsWith('//')) {
            url = `${window.location.protocol}//${window.location.host}${url}`;
        } else {
            url = `${window.location.protocol}${url}`;
        }
    }

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
    };

    const response = await fetch(url, requestOptions);
    const responseJson = await response.text();
    // console.log('!!!!!!!!!', responseJson); TODO приходит ошибка
    return JSON.parse(responseJson);
}

export async function requestJsonGet(url: string) {
    if (url.startsWith('/')) {
        if (!url.startsWith('//')) {
            url = `${window.location.protocol}//${window.location.host}${url}`;
        } else {
            url = `${window.location.protocol}${url}`;
        }
    }

    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    };

    const response = await fetch(url, requestOptions);
    const responseJson = await response.text();
    return JSON.parse(responseJson);
}
